import React, {useEffect, useState} from 'react'
import { default as ReactSelect, components } from 'react-select'

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          disabled={props.data.isDisabled} // Disable earned badges
        />{' '}
        <label>{props.label}</label>
      </components.Option>
    </div>
  )
}

const BadgeDropdown = ({
  stageBadges,
  courseBadges,
  onSelect,
  badgeSelected,
  disableEarnedBadges,
  disabled,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Map badges to options, marking earned badges as disabled
    const stageOptions = stageBadges.map((badge) => ({
      value: badge.id,
      label: badge.badges.name,
      isCourse: false,
      isDisabled:
        disableEarnedBadges &&
        badge.user_badge_progress &&
        badge.user_badge_progress.length > 0 &&
        (
          badge.user_badge_progress[0].completion_percentage < 100 ||
          badge.user_badge_progress[0].earned_at !== null
        ),
      isEarned:
        badge.user_badge_progress &&
        badge.user_badge_progress.length > 0 &&
        badge.user_badge_progress[0].earned_at !== null, // Flag earned badges
    }))

    let courseOptions = []

    courseOptions = courseBadges.map((badge) => ({
      value: badge.id,
      label: badge.badges.name,
      isCourse: true,
      isDisabled:
        disableEarnedBadges &&
        badge.user_badge_progress &&
        badge.user_badge_progress.length > 0 &&
        (
          badge.user_badge_progress[0].completion_percentage < 100 ||
          badge.user_badge_progress[0].earned_at !== null
        ),
      isEarned:
        badge.user_badge_progress &&
        badge.user_badge_progress.length > 0 &&
        badge.user_badge_progress[0].earned_at !== null, // Flag earned badges
    }))

    setOptions([...stageOptions, ...courseOptions])

  }, []);

  // Handle changes to selected badges
  const handleChange = (selectedOptions) => {
    // Ensure earned badges are not removed
    const earnedBadges = options.filter((option) => option.isEarned)
    const selectedBadges = [...earnedBadges, ...(selectedOptions || [])]
    const uniqueBadges = Array.from(
      new Map(selectedBadges.map((badge) => [badge.value, badge])).values()
    );

    onSelect(uniqueBadges)
  }

  return (
    <ReactSelect
      className="w-full"
      options={options}
      isMulti
      isDisabled={disabled}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{ Option }}
      onChange={handleChange}
      value={options.filter((option) => {
        let stage = false
        let course = false
        if (badgeSelected?.stage) {
          stage = badgeSelected.stage.includes(option.value)
        }
        if (badgeSelected?.course) {
          course = badgeSelected?.course.includes(option.value)
        }

        return stage || course
      })} // Keep selected badges
    />
  )
}

export default BadgeDropdown
